import {Injectable} from '@angular/core';

@Injectable()
export class PersistanceService {
  set(key: string, data: string): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
    }
  }

  public get(key: string): string {
    try {
      let str: string | null;
      str = localStorage.getItem(key);
      if (str) {
        return JSON.parse(str);
      } else {
        return '';
      }
    } catch (e) {
      return '';
    }
  }
}
